import React from "react";
import { Root } from "@/common/Styled/CommonStyled";
import ServiceUpdatePopup from "./EventPopup/ServiceUpdatePopup";

/**
 * 서비스 업데이트 안내 모달 단독 화면(시안 확인용).
 * 실제 진입 플로우 연동 시에는 ServiceUpdatePopup만 사용하면 됩니다.
 */
function ServiceUpdateAnnouncementComponent() {
  return (
    <Root style={{ minHeight: "100vh", position: "relative" }}>
      <ServiceUpdatePopup open />
    </Root>
  );
}

export default ServiceUpdateAnnouncementComponent;
